import axios from "axios";

export const BASE_API_URL = process.env.REACT_APP_CHAT_API_URL
  ? `${process.env.REACT_APP_CHAT_API_URL}/api`
  : "https://dev-greenback-app-chat.azurewebsites.net/api";

const axiosInstanceWidget = axios.create({
  baseURL: BASE_API_URL,
});

export default axiosInstanceWidget;
